import React, { Fragment, useState } from 'react';
import { DialogActions } from '@material-ui/core';
import Auth0Button from './../Auth0Button';
import Oauth2 from './oauth2Install';
import MuiAlert from '@material-ui/lab/Alert';
import Loading from '../../../../flowtrace-components/Loading';
import ApiFilter  from "./apiFilter"

const createAlert = (type, message) => {
  return (
    <MuiAlert key="alertMessage" severity={type} className="pt-0 pb-0">
      {message}
    </MuiAlert>
  );
};
export default function GenericConfigurationModal(props) {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);


  const authError = (error) => {
    console.log("authError", error);
    setMessage(createAlert("error", "We couldn't complete the verification."));
    if(error.original === "User closed the popup window")
      props.onInstall(false, false, "You didn't complete the integration.");
    else
      props.onInstall(false, false, error.description ? error.description:null); // Tell the page we got a failure
    setLoading(false);
  };

  const authSuccess = (profile) => {
    setLoading(true);
    Oauth2(profile.sub).then(data => {
      const resp = data && data.data ? data.data : data;
      if(resp && resp.success)
        setMessage(createAlert("success", "Installation succeeded."));
      else if(resp.message)
        setMessage(createAlert("warning", resp.message));
      else
        setMessage(createAlert("warning", "Something didn't go right."));
      props.onInstall(resp.success);
      }).finally(() => {
      setLoading(false);
    });
  };

  const install = <Auth0Button loading={loading} cbProfile={authSuccess} cbError={authError} reinstall={props.existing} connection={props.modal.id} />;

  const dialogButtons =
    <DialogActions style={{ justifyContent: "space-between" }} className="mx-auto pt-5 pb-3">
      {install}
      {props.cancelButton}
    </DialogActions>;

  if(!props.existing)
    return install;

  if(loading)
    return <Fragment> <Loading minimize={true}/> {dialogButtons} </Fragment>;

  return (
    <Fragment>
        <div>
          <p>You can choose to re-install {props.modal.title} integration:</p>
          <ApiFilter flowtraceUser={props.flowtraceUser} type="microsoft" />
          {message}
          {dialogButtons}
        </div>
    </Fragment>
  )
}